import type { ComponentProps } from 'react';

export const AcceptIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      {...props}
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M21.4142 7.00015L10.4759 17.9384L3.58655 10.5719L5.04728 9.20578L10.524 15.0619L20 5.58594L21.4142 7.00015Z'
        fill='white'
        fillRule='evenodd'
      />
    </svg>
  );
};
